import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import AnnouncementBar from "./AnnouncementBar";

export default function PublicLayout({ children }) {
    return (
        <div className="min-h-screen flex flex-col bg-ivory-200" data-testid="public-layout">
            <AnnouncementBar />
            <Navbar />
            <main className="flex-1">{children}</main>
            <Footer />
        </div>
    );
}
